import { RbacFeature, RbacFeatureDetails, RbacApiPermission } from '@evidentid/tprm-portal-lib/models/rbac';

type DashboardFeatures = Extract<RbacFeature,
    | RbacFeature.dashboardViewEntities
    | RbacFeature.dashboardSearchAndFilter
    | RbacFeature.dashboardDownloadData
    | RbacFeature.dashboardUploadContract
    | RbacFeature.dashboardAddAndEditEntity
    | RbacFeature.dashboardPauseEntity
    | RbacFeature.dashboardActivateDeactivateEntity
    | RbacFeature.dashboardCreateNewLink
    | RbacFeature.dashboardCopySubmissionLink
    | RbacFeature.dashboardViewPendingActions
    | RbacFeature.dashboardViewSubmissionHistory
    | RbacFeature.dashboardUploadEntityDocument
    | RbacFeature.evieChat
    | RbacFeature.entityNoteGet
    | RbacFeature.entityNoteCreate
>;

export const DASHBOARD_FEATURE_PERMISSIONS_MAP: Record<DashboardFeatures, RbacFeatureDetails> = {
    // Every role but Go App User has it, so it is what a role change to or from Go App User says is lost or gained.
    [RbacFeature.dashboardViewEntities]: {
        name: RbacFeature.dashboardViewEntities,
        label: 'View entities and their details',
        requiredPermissions: [
            RbacApiPermission.entitiesGet,
            RbacApiPermission.entityGet,
            RbacApiPermission.entityGetDetails,
        ],
    },
    [RbacFeature.dashboardSearchAndFilter]: {
        name: RbacFeature.dashboardSearchAndFilter,
        label: 'Search and apply advanced filters',
        requiredPermissions: [ RbacApiPermission.entitiesGet ],
    },
    [RbacFeature.dashboardDownloadData]: {
        name: RbacFeature.dashboardDownloadData,
        label: 'Download data',
        requiredPermissions: [ RbacApiPermission.entityGetExport ],
    },
    [RbacFeature.dashboardUploadContract]: {
        name: RbacFeature.dashboardUploadContract,
        label: 'Upload and review contracts',
        requiredPermissions: [ RbacApiPermission.contractExtractionPost ],
    },
    [RbacFeature.dashboardAddAndEditEntity]: {
        name: RbacFeature.dashboardAddAndEditEntity,
        label: 'Add/edit entity',
        requiredPermissions: [ RbacApiPermission.entityCreate, RbacApiPermission.entityPut ],
    },
    [RbacFeature.dashboardPauseEntity]: {
        name: RbacFeature.dashboardPauseEntity,
        label: 'Pause/unpause entity',
        requiredPermissions: [ RbacApiPermission.entityPut ],
    },
    [RbacFeature.dashboardActivateDeactivateEntity]: {
        name: RbacFeature.dashboardActivateDeactivateEntity,
        label: 'Activate / deactivate entity',
        requiredPermissions: [ RbacApiPermission.entityPut ],
    },
    [RbacFeature.dashboardCreateNewLink]: {
        name: RbacFeature.dashboardCreateNewLink,
        label: 'Create a new link',
        requiredPermissions: [ RbacApiPermission.verificationsPostOnDemand ],
    },
    [RbacFeature.dashboardCopySubmissionLink]: {
        name: RbacFeature.dashboardCopySubmissionLink,
        label: 'Copy submission link to clipboard',
        requiredPermissions: [ RbacApiPermission.entityGetSubmissionLink ],
    },
    [RbacFeature.dashboardViewPendingActions]: {
        name: RbacFeature.dashboardViewPendingActions,
        label: 'View entity pending actions',
        requiredPermissions: [ RbacApiPermission.actionsGet ],
    },
    [RbacFeature.dashboardViewSubmissionHistory]: {
        name: RbacFeature.dashboardViewSubmissionHistory,
        label: 'View submission history',
        requiredPermissions: [ RbacApiPermission.entityGetVerifications ],
    },
    [RbacFeature.dashboardUploadEntityDocument]: {
        name: RbacFeature.dashboardUploadEntityDocument,
        label: 'Upload entity document',
        requiredPermissions: [ RbacApiPermission.entityPostDocument ],
    },
    [RbacFeature.evieChat]: {
        name: RbacFeature.evieChat,
        label: 'Use Evie(virtual assistant)',
        requiredPermissions: [ RbacApiPermission.chatbotPostQuestion ],
    },
    [RbacFeature.entityNoteGet]: {
        name: RbacFeature.entityNoteGet,
        label: 'View entity notes',
        requiredPermissions: [ RbacApiPermission.entityGetEntityNote ],
    },
    [RbacFeature.entityNoteCreate]: {
        name: RbacFeature.entityNoteCreate,
        label: 'Create entity notes',
        requiredPermissions: [ RbacApiPermission.entityCreateEntityNote ],
    },
};
